<div class="illustration"><ng-content></ng-content></div>
<div class="description">
  <span class="title"><ng-content select="[title]"></ng-content></span>
  <span class="rv-title-03"><ng-content select="[subtitle]"></ng-content></span>
</div>
